import React from 'react';
export function LineupOverviewSection() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 md:p-10 mb-12" data-id="element-3659">
      <img src="https://cdn.magicpatterns.com/uploads/3DcsKxziX9fbWN1TyLgbkw/seibu-america-Wire-EDM-index.jpg" alt="Seibu Wire EDM Machine Lineup - Water and Oil Specification" className="w-full h-auto rounded-lg" data-id="element-3660" />
    </div>;
}